import React from "react";

const FlagIcon = ({
  color = "#9ca3af",
  size = 16,
  filled = false,
}: {
  color?: string;
  size?: number;
  filled?: boolean;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 1.5V14.5M3 1.5H13L10 5.5L13 9.5H3"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={filled ? color : "none"}
    />
  </svg>
);

export default FlagIcon;